import React from 'react'
import Safe from '../Components/Safe'
import WhyChoose from '../Components/WhyChoose'
import Faq from '../Components/Faq'

const AboutUs = () => {
  return (
    <>
        <div className="banner-allpage-sec">
        <div className="banner-content-sec text-center">
            <h1 className="first-head">About Us</h1>
            <h3 className="second-head"></h3>            
        </div>
    </div>
    <Safe/>
    <WhyChoose/>
    <Faq/>
    </>
  )
}

export default AboutUs